import { render, staticRenderFns } from "./DriverQuote.vue?vue&type=template&id=96bedeac&scoped=true&"
import script from "./DriverQuote.vue?vue&type=script&lang=js&"
export * from "./DriverQuote.vue?vue&type=script&lang=js&"
import style0 from "./DriverQuote.vue?vue&type=style&index=0&id=96bedeac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bedeac",
  null
  
)

export default component.exports